import { Disclosure } from '@headlessui/react';
import { Fragment } from 'react';
import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Modal } from '../../../../core/components/templates/Modal';
import InnerCheckbox from '../../../Disciplines/components/exercises/components/innerCheckbox';
import { practiceFilterStoreStore } from '../../stores/practiceFilterStore';

interface IModalFilter {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export default function ModalFilterPractices({
  isOpen,
  onClose,
  onSubmit,
}: IModalFilter) {
  const { rate, modality, essay, setRate, setEssay, setModality, reset } =
    practiceFilterStoreStore();

  const resetAll = () => {
    reset();
    onSubmit();
  };

  const handleRate = (value: string) => {
    const aux = [...rate];
    const idx = aux.findIndex((it) => it === value);

    if (idx >= 0) {
      aux.splice(idx, 1);

      setRate(aux);
    } else {
      aux.push(value);

      setRate(aux);
    }
  };

  const handleModality = (value: string) => {
    const aux = [...modality];
    const idx = aux.findIndex((it) => it === value);

    if (idx >= 0) {
      aux.splice(idx, 1);

      setModality(aux);
    } else {
      aux.push(value);

      setModality(aux);
    }
  };

  const handleEssay = (value: string) => {
    const aux = [...essay];
    const idx = aux.findIndex((it) => it === value);

    if (idx >= 0) {
      aux.splice(idx, 1);

      setEssay(aux);
    } else {
      aux.push(value);

      setEssay(aux);
    }
  };

  const applyFilters = () => {
    onSubmit();
  };

  return (
    <Modal
      position={window.innerWidth < 768 ? 'bottom' : 'top-right'}
      size='md'
      isOpen={isOpen}
      onClose={() => onClose()}
      className='xs:h-[90vh] xs:w-full sm:h-[75vh] md:h-[95vh] md:w-[35%]'
      title='Filtrar temas'
    >
      <div
        id='filterContainer'
        className='flex w-full flex-col gap-md overflow-x-auto px-2 py-2 xs:h-[58vh] sm:h-[48vh] md:h-[75vh]'
      >
        <Disclosure>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Modalidade
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                <InnerCheckbox
                  onChange={() => handleModality('enem')}
                  label='Enem'
                  checked={modality.includes('enem')}
                  id='practice-modality-enem'
                  value='enem'
                />
                <InnerCheckbox
                  onChange={() => handleModality('vestibular')}
                  label='Vestibular'
                  checked={modality.includes('vestibular')}
                  id='practice-modality-vestibular'
                  value='vestibular'
                />
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
        <div className='w-full border-b-hairline border-mono-color-lightest' />
        <Disclosure>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Aproveitamento
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                <InnerCheckbox
                  onChange={() => handleRate('over-half')}
                  label='Maior que 50%'
                  checked={rate.includes('over-half')}
                  id='practice-rate-over-half'
                  value='over-half'
                />
                <InnerCheckbox
                  onChange={() => handleRate('under-average')}
                  label='Menor ou igual a 50%'
                  checked={rate.includes('under-average')}
                  id='practice-rate-under-average'
                  value='under-average'
                />
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
        <div className='w-full border-b-hairline border-mono-color-lightest' />
        <Disclosure>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Redação
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                <InnerCheckbox
                  onChange={() => handleEssay('w_essay')}
                  label='Apenas simulados Com Redação'
                  checked={essay.includes('w_essay')}
                  id='practice-essay-with-essay'
                  value='w_essay'
                />
                <InnerCheckbox
                  onChange={() => handleEssay('n_essay')}
                  label='Apenas simulados SEM Redação'
                  checked={essay.includes('n_essay')}
                  id='practice-essay-no-essay'
                  value='n_essay'
                />
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
      </div>
      <div className='fixed bottom-0 left-0 flex w-full flex-row items-center justify-center gap-lg px-4 py-5'>
        <Button
          variant='text'
          className='w-1/2 xs:text-sm md:text-md'
          full
          onClick={() => resetAll()}
        >
          <Icon Icon='delete' type='material' className='text-sm' />
          Limpar seleção
        </Button>
        <Button
          className='w-1/2 xs:text-sm md:text-md'
          full
          onClick={() => applyFilters()}
        >
          Aplicar filtros
        </Button>
      </div>
    </Modal>
  );
}
